<template>
<div>
    <Header />
    <div class="desktop">
        <BlackHeaderCenter :headerText="headerText" :subText="subText" :fadedText="fadedText" />
    </div>
    <div class="mobile">
        <BlackHeaderMobile :headerText="headerText" :subText="subText" :fadedText="fadedText" :isTextinput="false" />
    </div>
    <BodyLinks />
    <b-container class="mt-4">
        <Activation />
        <b-alert variant="warning" show>
            Please do not reload this page, if you do, then go back to <router-link class="badge badge-warning" to="/products/shop">products</router-link>
        </b-alert>
        <form @submit.prevent="makePayment" action="">
            <b-row align-h="center" class="mt-3">
                <b-col cols="7" class="mt-5 mb-5">
                    <div class="card-container">
                        <p class="mt-2 address-title">Shipping Information</p>
                        <b-row>
                            <b-form-group class="col-md-6 mb-2" label-for="firstName">
                                <b-input-group class="">
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="person"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input type="text" required v-model="firstname" placeholder="First name"></b-form-input>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group class="col-md-6 mb-2" label-for="lastName">
                                <b-input-group class="">
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="person"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input type="text" required v-model="lastname" placeholder="Last name"></b-form-input>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group class="col-md-12 mb-2" label-for="phone">
                                <vue-tel-input @validate="numberChanged" v-bind="bindProps" class="form-control" v-model="phone"></vue-tel-input>
                            </b-form-group>
                            <b-form-group class="col-md-12 mb-2" label-for="email">
                                <b-input-group class="">
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="envelope"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input type="email" required v-model="order.recipient_info[0].email" placeholder="Email address"></b-form-input>
                                </b-input-group>
                            </b-form-group>

                            <b-form-group class="col-md-12 mb-4" label-for="address">
                                <b-input-group class="">
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="globe"></b-icon>
                                    </b-input-group-prepend>
                                    <vue-google-autocomplete required="" id="p-map" v-model="order.recipient_info[0].address" ref="address" classname="form-control" placeholder="Enter delivery address" v-on:placechanged="getAddressData">
                                    </vue-google-autocomplete>
                                </b-input-group>
                            </b-form-group>
                        </b-row>
                    </div>
                </b-col>
                <b-col cols="5" class="mt-5 mb-5">
                    <div class="grey-bg p-3">
                        <p class="d-flex justify-content-between">
                            <span>
                                {{order.product.name}}
                            </span>
                            <span class="font-weight-bold">
                                ${{order.product.discount_price}}
                            </span>
                        </p>
                        <p class="text-center"><img style="width:200px;height: 200px;" :src="order.product.images" alt=""></p>

                        <p class="d-flex justify-content-between">

                            <span class="text-uppercase">
                                SUB-TOTAL
                            </span>
                            <span>
                                ${{order.product.discount_price}}
                            </span>
                        </p>
                        <p class="d-flex justify-content-between">
                            <span class="font12">
                                Shipping
                            </span>
                            <span class="font12">
                                ${{order.totalShipping}}
                            </span>
                        </p>
                        <p class="d-flex justify-content-between">
                            <span class="font12">
                                Taxes
                            </span>
                            <span class="font12">
                                ${{order.taxes}}
                            </span>
                        </p>
                        <div class="font-weight-bold b-top d-flex justify-content-between pt-2">
                            <span class="">
                                Grand Total
                            </span>
                            <span class="">
                                ${{order.amount_due}}
                            </span>
                        </div>
                    </div>
                    <b-form-group class="mt-4 col-md-12 mb-3" label-for="input-1">
                        <button style="width:100%" :disabled="disableBtn" class="btn btn-warning"> Proceed to Payment
                            <font-awesome-icon :icon="['fas', 'arrow-right']" /> </button>
                    </b-form-group>
                </b-col>

            </b-row>
        </form>
    </b-container>
    <Footer />
</div>
</template>

<script>
import Header from "@/components/Header/Header.vue";
import BodyLinks from "@/components/BodyLinks.vue";
import Footer from "@/components/Footer.vue";
import BlackHeaderCenter from "@/components/BlackHeaderCenter.vue";
import BlackHeaderMobile from "@/components/BlackHeaderMobile.vue";
import Activation from "@/components/Activation.vue";
import VueGoogleAutocomplete from 'vue-google-autocomplete';

export default {
    name: 'checkout',
    components: {
        Header,
        BodyLinks,
        BlackHeaderCenter,
        BlackHeaderMobile,
        Activation,
        VueGoogleAutocomplete,
        Footer
    },
    data: function () {
        return {
            headerText: "Culture Store",
            btnText: 'Order',
            subText: "checkout your item and make payment",
            fadedText: "checkout",
            startRating: 2.567,
            imgUrl: require('../assets/images/dress.png'),
            portraitImg: require('../assets/images/dress-potrait.png'),
            quantity: 1,
            disableBtn: true,
            firstname: '',
            lastname: '',
            phone: '',
            address: '',
            bindProps: {
                mode: "international",
                placeholder: "Enter a phone number",
                name: "telephone",
                maxLen: 25,
                autoDefaultCountry: false
            },
            order: {
                amount_due: '',
                product: {
                    qty: ''
                },
                taxes: 0.0,
                recipient_info: [{
                    name: '',
                    address: '',
                    email: '',
                    phone: ''
                }],
                orders: []
            },

        }
    },
    mounted() {
        this.init();

    },
    computed: {
        cart: function () {
            return this.$store.getters.cart;
        },
        currentUser: function () {
            return this.$store.getters.currentUser;
        },
    },
    methods: {
        init() {
            let taxes = 0;
            this.order.totalShipping = 0;
            this.order.product.qty = 1;
            this.order.product = this.$route.params.product;
            console.log(this.order.product)
            taxes += parseFloat((this.order.product.business.tax_rate / 100) * this.order.product.discount_price)
            this.order.taxes = Math.round((taxes + Number.EPSILON) * 100) / 100
            const amount_due = parseFloat(this.order.product.discount_price + this.order.taxes + this.order.totalShipping)
            this.order.amount_due = Math.round((amount_due + Number.EPSILON) * 100) / 100
        },
        numberChanged: function ({
            number
        }) {
            this.order.recipient_info[0].phone = number
        },
        getAddressData: function (_addressData, placeResultData) {
            const country = placeResultData.address_components.find(ad => ad.long_name === _addressData.country);
            const country_code = country.short_name
            console.log(country_code)
            if (placeResultData.formatted_address !== null) {
                this.order.recipient_info[0].address = placeResultData.formatted_address;
                if (_addressData.country === process.env.VUE_APP_DEFAULT_COUNTRY) {
                    this.order.totalShipping += parseInt(this.order.product.delivery_info[0].local_shipping_fee == undefined ? 0 : this.order.product.delivery_info[0].local_shipping_fee);
                    this.order.amount_due = this.order.product.discount_price + this.order.totalShipping
                } else {
                    this.order.totalShipping += parseInt(this.order.product.delivery_info[0].intl_shipping_fee == undefined ? 0 : this.order.product.delivery_info[0].intl_shipping_fee);
                    this.order.amount_due = this.order.product.discount_price + this.order.totalShipping
                }
                this.disableBtn = false;
            }
        },
        makePayment() {
            this.order.orders = [{
                ...this.order.product
            }, ...this.order.orders]
            this.order.singleProduct = true
            this.order.recipient_info[0].name = this.firstname + ' ' + this.lastname
            this.$router.push({
                name: 'product-pay',
                params: {
                    order: this.order
                }
            })
            console.log(this.order)
        }
    }

}
</script>

<style lang="scss" scoped>
.form-control {
    border-radius: 0 8px 8px 0 !important;
    height: calc(2em + 0.75rem + 15px) !important;

}

.row {
    margin-left: 0 !important
}

.grey-bg {
    background: #f7f7f7;
}

.grey-bg img {
    height: 30vh;
    width: auto;
    border-radius: 5px
}

.b-top {
    border-top: 1px solid #76787b;
}

.col-2 {
    padding-left: 0 !important;
}

.custom-control {
    background: #565C63 !important;
    box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.1);
    border-radius: 4px !important;
    color: #fff !important
}
</style>
